import { Button, Card, Flex, Space, Tag, Typography } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheckCircle, faInfoCircle, faSync, faXmarkCircle } from "@fortawesome/pro-solid-svg-icons"
import { ApplicationStatus, MerchantStatusData } from "../../../domain/invoicing/rainforest"
import VSpace from "../../common/VSpace"
import { blue, green } from "@ant-design/colors"
import SetMerchantStatusControl from "./SetMerchantStatusControl"

type Props = {
  applicationStatus: ApplicationStatus
  merchantStatusData?: MerchantStatusData
  onStartApplication: () => void
  onManageApplication: () => void
  onGotIt: () => void
  onContactSupport: () => void
}

const MerchantStatus = ({
  applicationStatus,
  merchantStatusData,
  onStartApplication,
  onManageApplication,
  onGotIt,
  onContactSupport
}: Props) => {
  switch (applicationStatus) {
    case '':
      return (
        <Card style={{ borderColor: blue.primary, backgroundColor: blue[0] }}>
          <VSpace>
            <Flex justify="space-between" align="center">
              <div style={{width: '100%'}}>
                <strong>Submit Your SynkedUP Payments Application!</strong><br/>
                <Typography.Text type="secondary">Get started with SynkedUP Payments by submitting your application.</Typography.Text>
              </div>
              <VSpace style={{ textAlign: 'right' }}>
                <Space>
                  <Button type="primary" onClick={onStartApplication}>Start Application</Button>
                </Space>
              </VSpace>
            </Flex>
          </VSpace>
        </Card>
      )

    case 'CREATED':
    case 'IN_PROGRESS':
      return (
        <Card style={{ borderColor: blue.primary, backgroundColor: blue[0] }}>
          <VSpace>
            <Flex justify="space-between" align="center">
              <div style={{width: '100%'}}>
                <strong>Finish Your SynkedUP Payments Application</strong><br/>
                <Typography.Text type="secondary">Get started with SynkedUP Payments by submitting your application.</Typography.Text>
              </div>
              <VSpace style={{ textAlign: 'right' }}>
                <Space>
                  <Button type="primary" onClick={onManageApplication}>Complete Your Application</Button>
                </Space>
              </VSpace>
            </Flex>
          </VSpace>
        </Card>
      )

    case 'NEEDS_INFORMATION':
      return (
        <Card style={{ borderColor: '#FF4D4F', backgroundColor: '#FFF1F0' }}>
          <VSpace>
            <Flex justify="space-between" align="center">
              <div style={{width: '100%'}}>
                <strong>We Need More Information About Your Application</strong><br/>
                <Typography.Text type="secondary">Just provide a few more details.</Typography.Text>
              </div>
              <VSpace style={{ textAlign: 'right' }}>
                <Space>
                  <Tag color="blue">
                    <Space>
                      <FontAwesomeIcon icon={faInfoCircle} />
                      <span>Needs Information</span>
                    </Space>
                  </Tag>
                  <Button type="primary" onClick={onManageApplication}>Update Your Application</Button>
                </Space>
              </VSpace>
            </Flex>
          </VSpace>
        </Card>
      )

    case 'PROCESSING':
    case 'IN_REVIEW':
      return (
        <Card style={{ borderColor: '#FAAD14', backgroundColor: '#FFFBE6' }}>
          <VSpace>
            <Flex justify="space-between" align="center">
              <div style={{width: '100%'}}>
                <strong>Your Application Is Being Processed</strong><br/>
                <Typography.Text type="secondary">The application review process can take up to 3 business days.</Typography.Text>
              </div>
              <VSpace style={{ textAlign: 'right' }}>
                <Space>
                  <Tag color="#FAAD14">
                    <Space>
                      <FontAwesomeIcon icon={faSync} />
                      <span>Application Processing</span>
                    </Space>
                  </Tag>
                </Space>
              </VSpace>
            </Flex>
            <SetMerchantStatusControl merchantStatusData={merchantStatusData} />
          </VSpace>
        </Card>
      )

    case 'COMPLETED':
      return (
        <Card style={{ borderColor: green.primary, backgroundColor: green[0] }}>
          <VSpace>
            <Flex justify="space-between" align="center">
              <div style={{width: '100%'}}>
                <strong>Your SynkedUP Payments Application Was Approved!</strong><br/>
                <Typography.Text type="secondary">You're ready to send invoices with SynkedUP Payments.</Typography.Text>
              </div>
              <VSpace style={{ textAlign: 'right' }}>
                <Space>
                  <Tag color="green">
                    <Space>
                      <FontAwesomeIcon icon={faCheckCircle} />
                      <span>Application Approved</span>
                    </Space>
                  </Tag>
                  <Button onClick={onGotIt}>Got It!</Button>
                </Space>
              </VSpace>
            </Flex>
          </VSpace>
        </Card>
      )

    case 'DECLINED':
      return (
        <Card style={{ borderColor: '#FF4D4F', backgroundColor: '#FFF1F0' }}>
          <VSpace>
            <Flex justify="space-between" align="center">
              <div style={{width: '100%'}}>
                <strong>Your SynkedUP Payments Application Was Denied</strong><br/>
                <Typography.Text type="secondary">Contact our support team for more information.</Typography.Text>
              </div>
              <VSpace style={{ textAlign: 'right' }}>
                <Space>
                  <Tag color="red">
                    <Space>
                      <FontAwesomeIcon icon={faXmarkCircle} />
                      <span>Application Denied</span>
                    </Space>
                  </Tag>
                  <Button onClick={onContactSupport}>Contact Support</Button>
                </Space>
              </VSpace>
            </Flex>
          </VSpace>
        </Card>
      )

    default:
      return null
  }
}

export default MerchantStatus